import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const NationalAccount = {
	name: NAME,
	apiProvider,
	router,
};
